export default [
  {
    img: require('@/assets/badulina.jpg'),
    text: `<div>Курсы отличные!
    Могу порекомендовать их не только будущим экскурсоводам, но и
    тем, кто самообразовывается. Ведь лекции читают интерес&shy;нейшие
    люди нашего города - экскурсоводы, научные сотруд&shy;ники музеев,
    авторы книг о жизни Петербурга. Практичес&shy;кие занятия дают
    возмож&shy;ность, оттолкнувшись от ба&shy;зовых знаний, придумать,
    разработать и воплотить свои экскурсионные проекты. Благо&shy;даря
    этим курсам уже несколько лет дарю людям чудо под названием Петербург!</div>`,
    author: 'Анастасия Бадулина'
  },
  {
    img: require('@/assets/bagenova.jpg'),
    text: `Спасибо всем преподавателям и организаторам курсов по прог&shy;рамме
    «Организация, сопро&shy;вож&shy;дение, и экскурсионное обслужи&shy;вание туристов
    в Санкт-Петербурге и пригородах». Ма&shy;териал, который был дан на
    лекционных занятиях, актуа&shy;лен, интересен и адаптирован для
    дальнейшей профес&shy;сиональной деятельности.
    Но самое главное, что прог&shy;рамма курса позволяет слуша&shy;телям
    попробовать себя в процессе
    обучения в роли экскурсовода, ознакомиться с принципом работы с
    ауди&shy;торией.`,
    collapsed: `Есть возможность применить полученные теоретические зна&shy;ния на
    практике с учетом ее особенностей. Благодарим за профессионализм,
    ответст&shy;венность и доброжелательную атмосферу. В качестве поже&shy;лания
    для еще более успешной подготовки специалистов, воз&shy;можно, стоит
   сделать больший акцент на организационные моменты при оформлении
   доку&shy;ментов в музейных и дворцово-парковых комплексах.`,
    author: 'Татьяна Баженова'
  },
  {
    img: require('../assets/tkachenko.jpg'),
    text: `Хочу сказать огромное спасибо организаторам курсов! Уже имея
    некоторое отношение к турбизнесу, решила пойти еще и на курсы
     экскурсоводов (для получения аккредитации). Поло&shy;жившись на
     свою интуицию, выбрала курсы во Дворце учащейся молодежи, и
     не ошиблась! Удобное место, ком&shy;фортное время проведения
     за&shy;нятий, а главное - замеча&shy;тель&shy;ный (можно сказать уникаль&shy;ный)
      состав преподавателей!`,
    collapsed: `Это люди, лекции которых собирают
    полные аудитории, многие из преподавателей являются
    авторами книг о Санкт-Петербурге! На занятия ходили как на
    праздник! Непринужденная атмосфера, ца&shy;рящая на курсах,
    позволила приобрести новых друзей-единомышленников,
    обожающих Санкт-Петербург! Открылись новые возможности
    трудоуст&shy;ройства! Спасибо организа&shy;торам! Заниматься любимым
    делом и при этом еще зараба&shy;тывать - это здорово!`,
    author: 'Татьяна Ткаченко'
  },
  {
    img: require('../assets/davidova.jpg'),
    text: `О курсах узнала совершенно случайно. Ехала в метро, увидела
    рекламу, запомнила телефон и позвонила. Разго&shy;ва&shy;ривая с
    менеджером об учебном плане, удивлялась, почему так долго нужно
    учиться, когда другие курсы предлагают всего лишь два месяца.
    Но когда начались занятия, поняла, что и 7 месяцев мало!
    Хотелось еще и еще слушать лекции, впиты&shy;вать всю информацию об
    исто&shy;рии нашей страны и о нашем городе.`,
    collapsed: `Отдельно хочу выразить
    благо&shy;дарность преподавателям и работникам курсов. Программа
    была составлена отлично. Вре&shy;мя на лекциях проходило неза&shy;метно,
    а семь месяцев проле&shy;тели как одна неделя. Даже если Вы не
    планируете менять свою профессию, все равно Вам будет очень
    интересно прослу&shy;шать курс исторических лекций. Реко&shy;мендую всем!`,
    author: 'Ярослава Давыдова'
  },
  {
    img: require('../assets/rtov.jpg'),
    text: `В 2015-2016г. мне предста&shy;ви&shy;лась возможность пройти обу&shy;чение
    на курсах экскурсо&shy;во&shy;дов. Высокая квалификация и профес&shy;сионализм
    преподава&shy;тельского состава, таких как Силичева Н.М.,
    Слепенкова О.В., Никитина Г.И., Бойко Н.Г., Скульская Н.М.,
    Козловская Л.В., Логунова М.О., Юхнева Е.Д. и др., доступная
    форма подачи учебного мате&shy;риала, позволила мне получить
    необходимые знания. Данные курсы будут одинаково инте&shy;ресны не
    только тем, кто хотел бы освоить новую спе&shy;циальность экскур&shy;со&shy;вода,
    но и тем, кто хотел бы больше узнать об истории города, региона.`,
    author: 'Вячеслав Ртов'
  },
  {
    img: require('../assets/sigaeva.jpg'),
    text: `Два года назад мне посчастли&shy;вилось пройти обучение на Курсах
    экскурсоводов, организо&shy;ванных  Дворцом учащейся моло&shy;дежи, где
    у меня появилась возможность узнать  не только много нового и
    интересного, но и получить Новую востребован&shy;ную профессию.
    Одним из гла&shy;вных преимуществ курсов явля&shy;ется расположение – в
    центре города, рядом с метро, а вечер&shy;нее время занятий,
    позволяет совмещать их с работой. Во-вторых преподавание и
    методы обучения  отличаются высоким профессионализмом и
    мас&shy;терством.`,
    collapsed: `Занятия ведут лучшие экс&shy;кур&shy;соводы – методисты
    компании, а их знания, опыт и любовь к профессии, переда&shy;ются и
    тем, кто обучается на курсах. Ведущие специалисты и научные
    сотрудники музеев СПб помо&shy;гают заново открыть  историю города,
    его архитек&shy;туру и культуру. Теория не отстает от практики -
    проводятся интересные, позна&shy;ва&shy;тельные учебно-методи&shy;чес&shy;кие
    экскурсии. Далее начинается  настоящее творчество: на основе
    полу&shy;чен&shy;ных знаний Вы пишите, созда&shy;ете свою экскур&shy;сию (сначала
    обзорную) под руководством вашего настав&shy;ника-методиста. Это
    нелегкий путь, но вам обязательно подскажут, испра&shy;вят, напра&shy;вят.
    И вот текст готов и вас ждет испытание - первый проезд с
    микрофоном и первый экзамен. А впереди – изучение пригородов и
    подго&shy;товка трас&shy;со&shy;вой экскурсии. В течение достаточно
    короткого времени вы приобретаете ключевые навыки, а, главное,
    желание скорее применить их. Даль&shy;нейшее  зависит от Вас – если
    вы полны решимости и хотите работать, то прохо&shy;дите ста&shy;жи&shy;ровку
    в фирме, где вам помогают стать  насто&shy;ящим профессионалом. В
    любом слу&shy;чае знания, полученные на кур&shy;сах, останутся с вами.
    Я бла&shy;годарна Курсам i-gid  и моим любимым методистам –
    экскур&shy;соводам за новую интересную работу, которая сделала мою
    жизнь яркой и насыщенной!`,
    author: 'Алла Сигаева'
  }
]



// WEBPACK FOOTER //
// ./src/data/Feedback.js